interface User {  
  displayName: String
  userId: String
  login: String,
  token: String
}

interface UseAuthStoreReturn {
  userTenants: Ref<any[]>;
  user: Ref<User>;
  setUserTenants: (data: any[]) => void;
  setUser: (userData: User) => void;
  clear: () => void;
}

export const useAuthStore = (): UseAuthStoreReturn => {
  // Define state
  const userTenants = useState<any[]>('userTenants', () => [])
  const user = useState<User>('user', () => ({} as User))

  // Define actions
  const setUserTenants = (data: any[]) => {
    userTenants.value = data
  }

  const setUser = (userData: User) => {
    user.value = userData
  }

  const clear = () => {
    userTenants.value = []
    user.value = {} as User
  }

  // Return state and actions
  return {
    clear,
    setUser,
    setUserTenants,
    user,
    userTenants,
  }
}
